import { render, staticRenderFns } from "./test_props.vue?vue&type=template&id=11ebbf13&"
import script from "./test_props.vue?vue&type=script&lang=js&"
export * from "./test_props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports